"use client";

import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
import { PRODUCTS_QUERY_BY, PRODUCTS_QUERY_BY_WEIGHTS, PRODUCTS_VECTOR_QUERY } from "./queryConfig";

export const PRODUCTS_INDEX_NAME = "products";

export function buildTypesenseSearchClient() {
  const host = process.env.NEXT_PUBLIC_TYPESENSE_HOST ?? "";
  const apiKey = process.env.NEXT_PUBLIC_TYPESENSE_SEARCH_ONLY_KEY ?? "";

  const adapter = new TypesenseInstantSearchAdapter({
    server: {
      apiKey,
      nodes: [{ host, port: 443, protocol: "https" }],
      connectionTimeoutSeconds: 5,
    },
    additionalSearchParameters: {
      query_by: PRODUCTS_QUERY_BY,
      query_by_weights: PRODUCTS_QUERY_BY_WEIGHTS,
      vector_query: PRODUCTS_VECTOR_QUERY,
      highlight_full_fields: PRODUCTS_QUERY_BY,
      exclude_fields: "embedding",
      // PLP browsing sends `q=*`, which drowns out real queries in popular-queries analytics.
      enable_analytics: false,
    },
  });

  return adapter.searchClient;
}
